<template>
    <div v-if="innerVisible" :class="['ref020-alert-bar', 'ref020-alert-' + type]" role="alert">
        <a v-if="linkUrl" :href="linkUrl" class="ref020-alert-link">
            {{ message }}
        </a>
        <span v-else class="ref020-alert-message">{{ message }}</span>

        <button v-if="dismissible" type="button" class="ref020-alert-close" @click="onClose" aria-label="닫기">×</button>
    </div>
</template>

<script>
// REF-020 Phase 2-H (2026-05-04) — 신규 alert bar SSOT Vue 컴포넌트 (M3 δ 다섯 번째)
//
// 결정 8 / 결정 20 — bl_error_msg 등 컨텐츠 영역 상단 alert. 헤더 우상 배지 형태에서 분리.
// 결정 14 (검토 8) — 총괄 한정 노출 + 닫기 버튼.
//
// props:
//   visible (Boolean)   — 노출 여부 (기본 true)
//   type (String)       — 'danger' / 'warning' / 'info' (기본 'danger')
//   message (String)    — 본문
//   linkUrl (String|null) — 클릭 가능 링크 (예: /admin/bl-info)
//   dismissible (Boolean) — 닫기 버튼 노출 여부 (기본 true)
//
// 닫기 클릭 시 'close' event emit + 컴포넌트 자체 v-show false (data 로컬 상태)
export default {
    name: 'app-alert-bar',
    props: {
        visible: {
            type: Boolean,
            default: true,
        },
        type: {
            type: String,
            default: 'danger',
            validator: (value) => ['danger', 'warning', 'info'].includes(value),
        },
        message: {
            type: String,
            required: true,
        },
        linkUrl: {
            type: String,
            default: null,
        },
        dismissible: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            // hot-fix #8 (2026-05-05): 자체 hide 처리. 부모 v-on:close 핸들러 없어도 닫기 동작
            innerVisible: this.visible,
        };
    },
    watch: {
        visible(newVal) {
            this.innerVisible = newVal;
        },
    },
    methods: {
        onClose() {
            this.innerVisible = false;
            this.$emit('close');
        },
    },
};
</script>

<style scoped>
.ref020-alert-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
    margin: 0.5rem 1rem;
    font-size: 1rem;
}
.ref020-alert-danger {
    background: #fee2e2;
    border: 1px solid #fecaca;
    color: #991b1b;
}
.ref020-alert-warning {
    background: #fef3c7;
    border: 1px solid #fcd34d;
    color: #92400e;
}
.ref020-alert-info {
    background: #dbeafe;
    border: 1px solid #93c5fd;
    color: #1e3a8a;
}
.ref020-alert-link {
    color: inherit;
    text-decoration: underline;
    flex-grow: 1;
}
.ref020-alert-link:hover {
    text-decoration: none;
}
.ref020-alert-message {
    flex-grow: 1;
}
.ref020-alert-close {
    background: transparent;
    border: none;
    font-size: 1.25rem;
    line-height: 1;
    cursor: pointer;
    padding: 0 0.5rem;
    color: inherit;
    flex-shrink: 0;
}
.ref020-alert-close:hover {
    opacity: 0.7;
}
</style>
